import { APP_TYPE, AppType } from "../app.type";
import { Inject, Injectable } from "@angular/core";
import { BusinessConfigServiceType } from "./business-config.service.type";
import { getWorkHistoryByWorkType } from "../api.service";
import { WorkHistory } from "../../../../shared/models/workHistory";

@Injectable()
export class BusinessConfigService implements BusinessConfigServiceType {
  constructor(@Inject(APP_TYPE) private app: AppType) {}
  public history: WorkHistory[] = [];

  async runWarehousePartsUpdate() {
    this.app.spinner.showSpinner();
    await this.app.operations.triggerWork("warehouse-parts-update");
    this.app.spinner.hideSpinner();
    setTimeout(async () => {
      await this.getHistory();
    }, 5000);
  }

  async getHistory(): Promise<void> {
    this.history = await this.getWorkHistory();
  }

  async getWorkHistory(): Promise<WorkHistory[]> {
    this.app.spinner.showSpinner();
    const history = await getWorkHistoryByWorkType(
      this.app.customers.expectCurrent,
      "warehouse-parts-update"
    );

    history.forEach((item: any) => {
      if (item.complete_time == null) {
        item.duration = this.app.getText(`operations.inProgressMessage`);
      } else {
        const duration = Number(item.complete_time) - Number(item.create_time);
        item.duration = `${(duration / 1000 / 60).toFixed(3).toString()} min`;
      }
    });

    this.app.spinner.hideSpinner();

    return history;
  }

  getTypeText(type: string): string {
    switch (type) {
      case "warehouse-parts-update":
        type = "warehousePartsUpdate";
        break;
    }

    return this.app.getText(`businessConfig.${type}`);
  }
}
